import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetProduction_invoices_invoiceIdDownload = z.any()
export type TagsGetProduction_invoices_invoiceIdDownload = z.infer<typeof tagsGetProduction_invoices_invoiceIdDownload>

export const paramsGetProduction_invoices_invoiceIdDownload = z.object({ "invoiceId": z.string() })
export type ParamsGetProduction_invoices_invoiceIdDownload = z.infer<typeof paramsGetProduction_invoices_invoiceIdDownload>

export const responseGetProduction_invoices_invoiceIdDownload = z.any()
export type ResponseGetProduction_invoices_invoiceIdDownload = z.infer<typeof responseGetProduction_invoices_invoiceIdDownload>

interface IGetProduction_invoices_invoiceIdDownload extends BaseMethodType {
  tags: TagsGetProduction_invoices_invoiceIdDownload,
  params: ParamsGetProduction_invoices_invoiceIdDownload,
  response: ResponseGetProduction_invoices_invoiceIdDownload
}
export const URL = '/production-invoices/:invoiceId/download'
export const validation = {
  get: {
    tags: tagsGetProduction_invoices_invoiceIdDownload,
    params: paramsGetProduction_invoices_invoiceIdDownload,
    response: responseGetProduction_invoices_invoiceIdDownload
  }
}
export interface Production_invoices_invoiceIdDownload extends BaseRouteType {
  get: IGetProduction_invoices_invoiceIdDownload
}